import { parseMoney } from './';

import type { MoneyAmount } from './';

/**
 * returns true if the two supplied values are equal after being parsed as floats
 */
export const amountsMatch = (amount1: MoneyAmount, amount2: MoneyAmount): boolean => {
	return parseMoney(amount1) === parseMoney(amount2);
};
